export default function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}


//////////////////
// WEBPACK FOOTER
// ./~/@popperjs/core/lib/dom-utils/getNodeName.js
// module id = 42
// module chunks = 1